import isGravityWebsiteHandoffId from './isGravityWebsiteHandoffId.js';

let activeHandoffId = '';

export const rememberGravityWebsiteHandoffId = (handoffId = '') => {
  const normalizedHandoffId = String(handoffId || '').trim();
  activeHandoffId = isGravityWebsiteHandoffId(normalizedHandoffId) ? normalizedHandoffId : '';
  return activeHandoffId;
};

export const readRememberedGravityWebsiteHandoffId = () => {
  return activeHandoffId;
};

export const clearRememberedGravityWebsiteHandoffId = (handoffId = '') => {
  const normalizedHandoffId = String(handoffId || '').trim();
  if (!normalizedHandoffId || activeHandoffId === normalizedHandoffId) {
    activeHandoffId = '';
  }
};
